<template>
  <Container :class="$style.container">
    <Card
      :class="$style.card"
    >
      <template v-slot:header>
        <div>
          <HeadingSmall>
            Device Certificates
          </HeadingSmall>
        </div>
      </template>
    </Card>

    <Card
      :class="$style.card"
    >
      <template v-slot:header>
        <div>
          <HeadingSmall>
            User Certificates
          </HeadingSmall>
        </div>
      </template>
    </Card>
  </Container>
</template>

<script>
import {
  Card,
  Container,
  HeadingSmall,
} from '@jumpcloud/ui-components';

export default {
  name: 'PkiCertificateDistribution',

  components: {
    Card,
    Container,
    HeadingSmall,
  },

};
</script>

<style module>
.container {
  background-color: var(--jcWhite50);
}

.card {
  margin-bottom: var(--jc-spacer-medium);
  max-width: 40ch;
}
</style>
